export const defaultState = () => {
  let defaultStateValues = {}

  defaultStateValues = {
    welcome: {
      currentStep: 1,
      data: {
        pageObjective: "",
        industries: [],
      },
      hoverPageObjective: "",
      othersObjective: "",
      isDisabledBrowseTemplate: false
    },
    widget: {
      currentStep: 1,
      isClosed: true, // Default is closed
      isSubmitStep: false,
      // submittingStatus:
      // 0 = hide loading, 1 = loading, 2 = success, 3 = failure
      submittingStatus: 0, 
      data: {
        jobRole: {type: "", value: ""},
        businessType: ""
      }
    }
  };


  // const shopifyDomain = window.___gemShopInfo.shopifyDomain;
  // const locaDataKey = `__gpNewOnboarding__${shopifyDomain}`;
  // if ((locaDataKey in localStorage)) {
  //   try {
  //     const lastSurvey = JSON.parse(localStorage.getItem(locaDataKey));
  //     // eslint-disable-next-line no-console
  //     console.log("las", lastSurvey);

  //   } catch (err) {
  //     // eslint-disable-next-line no-console
  //     console.log(err);
  //   }
  // }

  return defaultStateValues;
};

const state = defaultState();

export default state;
